import React, { useState, useEffect } from "react";
import { Row, Col, Card, Table, Button } from "react-bootstrap";
import { useParams } from "react-router-dom";
import axios from "axios";
import { LinkContainer } from "react-router-bootstrap";

function FedOBScreen() {
  const [officeBearers, setOfficeBearers] = useState([]);
  const url = useParams();

  useEffect(() => {
    const fetchofficeBearers = async () => {
      const response = await axios.get(`/api/data/fed-ob/${url.term}`);

      const sortedData = response.data.sort((a, b) => a.order - b.order);

      console.log(response.data);
      setOfficeBearers(sortedData);
    };
    fetchofficeBearers();
  }, []);

  return (
    <div>
      <h2>Federation Office Bearers</h2>
      <div>
        <div>
          <Row>
            {officeBearers.map((user) => (
              <Col
                style={{ margin: "1em 0" }}
                lg={6}
                md={12}
                xs={12}
                key={user.id}
              >
                <Card className="obInfoCard">
                  <Row>
                    <Col xs={4}>
                      <Card.Img
                        className="obInfoImage"
                        style={{ border: "0", borderRadius: "15px" }}
                        src={user.photo}
                        alt=""
                      />
                    </Col>
                    <Col xs={8}>
                      <Card.Body>
                        <Row className="obInfoBodyTop">
                          <Card.Title
                            style={{
                              fontSize: "22px",
                              fontWeight: "700",
                              color: "#3f0986",
                            }}
                          >
                            {user.name}
                          </Card.Title>
                          <Card.Subtitle
                            style={{ fontSize: "20px", color: "#4d0020" }}
                          >
                            {user.designation}
                          </Card.Subtitle>
                        </Row>
                        <Row style={{ marginTop: "10px" }}>
                          <Card.Subtitle
                            style={{
                              fontSize: "18px",
                              textTransform: "capitalize",
                              color: "#4d0020",
                            }}
                          >
                            JSG {user.group} | {user.region} Region
                          </Card.Subtitle>
                          <Col>
                            <p className="obInfoText1">
                              <i class="fa-solid fa-phone"></i> {user.mobile}
                            </p>
                          </Col>
                        </Row>
                        <Row>
                          <p className="obInfoText1">
                            <i class="fa-solid fa-envelope"></i> {user.email}
                          </p>
                        </Row>
                      </Card.Body>
                    </Col>
                  </Row>
                </Card>
              </Col>
            ))}
          </Row>
        </div>
      </div>
    </div>
  );
}

export default FedOBScreen;
